var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import axios from 'axios';
import { useAPI } from '.';
const s3Upload = (file, uploadTo, axiosParams) => {
    const formData = new FormData();
    Object.entries(uploadTo.fields).forEach(([key, value]) => {
        formData.append(key, value);
    });
    formData.append('file', file);
    return axios(Object.assign({ method: 'POST', url: uploadTo.url, data: formData, headers: {
            'Content-Type': 'multipart/form-data'
        } }, axiosParams));
};
const uploadFile = ({ post, del }, file, body, { onDBDocCreated, onUploadProgress, canceler }) => __awaiter(void 0, void 0, void 0, function* () {
    let id;
    try {
        const res = (yield post({
            url: '/files',
            data: body,
            misc: {
                cancelToken: canceler === null || canceler === void 0 ? void 0 : canceler.token
            }
        }));
        id = res.data.id;
        if (onDBDocCreated)
            yield onDBDocCreated(res.data);
        yield s3Upload(file, res.data.uploadTo, {
            cancelToken: canceler === null || canceler === void 0 ? void 0 : canceler.token,
            onUploadProgress: (e) => {
                if (onUploadProgress)
                    onUploadProgress({
                        loaded: e.loaded,
                        total: e.total,
                        progress: Math.round((e.loaded * 100) / e.total)
                    });
            }
        });
        return res.data;
    }
    catch (err) {
        if (axios.isCancel(err) && id) {
            del({ url: `/files/${id}` }).catch((err) => {
                console.error(err);
            });
        }
        throw err;
    }
});
export const useFileUpload = () => {
    const { post, del } = useAPI();
    return useCallback((file, body, params) => uploadFile({ post, del }, file, body, params), [post, del]);
};
//# sourceMappingURL=useFileUpload.js.map